// extracted by mini-css-extract-plugin
export default {"chat_type":"TestView_chat_type__10jGJ"};